import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()

export class SendDataService {

    constructor(private http: HttpClient) { }


    addData(url, params) {
        return this.http.post<any>(url, params);
    }

    setDataSend(url, params) {
        return this.http.post<any>(url, params);
    }
    bajaBehiculo(url, params) {
        return this.http.post<any>(url, params);
    }

    getOrHistory(url, params) {
        return this.http.post<any>(url, params);
    }

    getVehicleState() {
        const _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/GetAllStateCarTypes`;
        return this.http.post(_URL_, {});
    }
    getVehicleEngine(){
        const _URL_ = `${environment.ENTORNO}Services/General/FuelTypesService.svc/GetAll`;
        return this.http.post(_URL_, {});
    }

    getAllStateCarTypes(url) {
        return this.http.post<any>(url, '');
    }

    getUbicaciones(url, params) {
        return this.http.post<any>(url, params);
    }


    estadoCarroceria(url, params) {
        return this.http.post<any>(url, params);
    }

    getCitas(url, params) {
        return this.http.post<any>(url, params);
    }

}
